import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommissionSummaryRoutingModule } from './commission-summary-routing.module';
import { ReviewCommissionsSearchComponent } from './review-commissions-search/review-commissions-search.component';
import { ReviewCommissionsComponent } from './review-commissions/review-commissions.component';
import { SearchByProductComponent } from './search-by-product/search-by-product.component';
import { SearchByCommStructureComponent } from './search-by-comm-structure/search-by-comm-structure.component';
import { HomeModule } from '../home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationModule } from '../notification.module';
import { MaterialModule } from '../material/material.module';
import { ByUserEmployeeWiseComponent } from './by-user-employee-wise/by-user-employee-wise.component';
import { UploadJsonComponent } from './upload-json/upload-json.component';
import { DataPropertyGetterPipe } from './data-property-getter-pipe/data-property-getter.pipe';
import { CommissionPlanComponent } from './commission-plan/commission-plan.component';
import { ReviewCommissionsSearchSupComponent } from './review-comms-search-sup/review-comms-search-sup.component';
import { SearchReportsGetComponent } from './search-reports-get/search-reports-get.component';
import { SearchReportsViewComponent } from './search-reports-view/search-reports-view.component';
import { UploadHeadersComponent } from './upload-headers/upload-headers.component';
import { ReviewCommsSearchRepComponent } from './review-comms-search-rep/review-comms-search-rep.component';
import { UpdateCommissionsUiComponent } from './update-commissions-ui/update-commissions-ui.component';
import { CommissionsSummarySearchComponent } from './commissions-summary-search/commissions-summary-search.component';
import { CommissionsSummaryGetComponent } from './commissions-summary-get/commissions-summary-get.component';
import { CommReportConfigComponent } from './commission-report-config/comm-report-config.component';
import { CommReportApprovalStatusModalComponent } from './commission-report-config/comm-report-approval-status-modal.component';

@NgModule({
  declarations: [
    ReviewCommissionsSearchComponent,
    ReviewCommissionsComponent,
    SearchByProductComponent,
    SearchByCommStructureComponent,
    ByUserEmployeeWiseComponent,
    UploadJsonComponent,
    DataPropertyGetterPipe,
    CommissionPlanComponent,
    ReviewCommissionsSearchSupComponent,
    SearchReportsViewComponent, 
    SearchReportsGetComponent, 
    UploadHeadersComponent, ReviewCommsSearchRepComponent, UpdateCommissionsUiComponent, CommissionsSummarySearchComponent, CommissionsSummaryGetComponent,
    CommReportConfigComponent,
    CommReportApprovalStatusModalComponent
  ],
  imports: [
    CommonModule,
    CommissionSummaryRoutingModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule,
    NotificationModule,
    MaterialModule,
    DragDropModule,
    ScrollingModule
  ]
})
export class CommissionSummaryModule { }
